import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface IClientUsersService {
  codEmpresa?: number;
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  codUsuAcesso?: string;
  reqBody?: ReqBodyType;
  usuario?: string;
}

class ClientUsersService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listClientUsers = async ({
    codEmpresa,
    codUsu,
    perfilUsu,
    token,
  }: IClientUsersService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadAcesso?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };

  createClientUser = async ({
    reqBody,
    token,
  }: IClientUsersService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_CadAcesso',
      reqBody,
    });
  };

  getClientUser = async ({
    codUsu,
    perfilUsu,
    codEmpresa,
    codUsuAcesso,
    token,
  }: IClientUsersService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadAcessoAcao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&codUsuAcesso=${codUsuAcesso}`,
    });
  };

  updateClientUser = async ({
    reqBody,
    token,
  }: IClientUsersService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_CadAcessoAlt',
      reqBody,
    });
  };

  deleteClientUser = async ({
    reqBody,
    token,
  }: IClientUsersService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_CadAcessoAcao',
      reqBody,
    });
  };

  getPermissionsOptions = async ({ token, codUsu, perfilUsu, codEmpresa }: IClientUsersService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Paginas?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}`,
    });
  };
}

export default new ClientUsersService();
